import React from 'react'

const Card = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`bg-white dark:bg-navy-deep rounded-xl shadow-md border border-navy-pale dark:border-navy-base ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}

export default Card